module.exports = __webpack_public_path__ + "static/media/Results-6.3ea30370.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-6.jpg
// module id = 369
// module chunks = 0